import { Box, Input, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'

import React, { useEffect } from 'react'

import avalancheImage from '@react/images/avalanche.png'
import baseImage from '@react/images/base.png'
import baseSepoliaImage from '@react/images/baseSepolia.png'
import ethereumImage from '@react/images/ethereum.png'
import fujiImage from '@react/images/fuji.png'
import hardhatImage from '@react/images/hardhat.png'
import plumeImage from '@react/images/plume.png'
import plumeTestnetImage from '@react/images/plumeTestnet.png'
import sepoliaImage from '@react/images/sepolia.png'
import unconnectedImage from '@react/images/unconnected.png'
import { useAppKitNetwork, useAppKitProvider } from '@reown/appkit/react'

import { attachToStageThunk } from '@react/chainThunks/attachToStageThunk'
import { connectToChainThunk } from '@react/chainThunks/connectToChainThunk'
import { loginToChainThunk } from '@react/chainThunks/loginToChainThunk'
import { chainActions } from '@react/redux/chainSlice'
import { poolActions } from '@react/redux/poolSlice'
import {
  OtStore,
  setupStoreWithInitialStateWithChainConnection,
  useOtChainState,
  useOtDispatch,
  useOtSelector,
} from '@react/redux/store'
import { getRequiredAddress } from '@shared/conversions'
import {
  ChainConfiguration,
  ChainIconName,
  convertToAppKitNetwork,
  findStageConfiguration,
  STAGE_CONFIGURATIONS,
  StageConfiguration,
} from '@shared/DeploymentConfigs'
import { StageName } from '@shared/Enums'
import { logOT } from '@shared/loggingShared'
import { BrowserProvider, Eip1193Provider, JsonRpcSigner } from 'ethers'
import { useStore } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { appKitNetworks } from '@react/components/AppKitWrapper'

/* eslint no-restricted-globals:0*/

const chainImageMap: Record<ChainIconName, string> = {
  ethereum: ethereumImage,
  avalanche: avalancheImage,
  sepolia: sepoliaImage,
  fuji: fujiImage,
  base: baseImage,
  baseSepolia: baseSepoliaImage,
  hardhat: hardhatImage,
  plume: plumeImage,
  plumeTestnet: plumeTestnetImage,
  unconnected: '',
}
type ChainIconProps = { chainName: ChainIconName }
export const ChainIcon: React.FC<ChainIconProps> = (props) => {
  const src = chainImageMap[props.chainName] || unconnectedImage
  return (
    <Box
      component="img"
      src={src}
      alt={props.chainName}
      sx={{ width: 24, height: 24 }} // Adjust the size as needed
    />
  )
}

export function ChainSelectorButtonMenu(): React.ReactElement {
  const {
    chainConfiguration,
    chainConfiguration: { providerReadOnly, chainConfigurationName, perimeterAddresses, chainId: chainConfigChainId },
    stageConfiguration: { chainConfigurations, stageName },
    userConnection: { accountAddr, walletEnum, roleEnum },
  } = useOtChainState()
  const { isInitialized } = useOtSelector((state) => state.poolState)
  const store = useStore() as OtStore
  const isLocalhost = location.hostname === 'localhost'

  const { walletProvider } = useAppKitProvider<Eip1193Provider>('eip155')
  const { chainId: appKitChainId, switchNetwork } = useAppKitNetwork()
  const navigate = useNavigate()
  const dispatch = useOtDispatch()
  const [selectedChainConfigurationName, setSelectedChainConfigurationName] = React.useState<string>(
    chainConfiguration?.chainConfigurationName ?? ''
  )

  const [selectedStageName, setSelectedStageName] = React.useState<StageName>(stageName ?? 'local')
  const [networkMismatchMessage, setNetworkMismatchMessage] = React.useState<string | undefined>(undefined)
  const [switchToChainId, setSwitchToChainId] = React.useState<number | undefined>(undefined)

  async function handleChangeChainSelection(chainConfigurationName: string): Promise<void> {
    logOT.info('handleChangeChainSelection handleChangeChainSelection chainConfigurationName', chainConfigurationName)
    localStorage.setItem('chainConfigurationName', chainConfigurationName)
    setSelectedChainConfigurationName(chainConfigurationName)

    const chainConfiguration = chainConfigurations.find(
      (chainConfig) => chainConfig.chainConfigurationName === chainConfigurationName
    ) as ChainConfiguration

    const appKitNetwork = convertToAppKitNetwork(chainConfiguration)
    logOT.info('chainConfigurationName switchNetwork NETWORK SWITCH FROM MENU', appKitNetwork, appKitChainId)
    switchNetwork(appKitNetwork as any)
    setSwitchToChainId(chainConfiguration.chainId)
  }

  useEffect(() => {
    if (switchToChainId && appKitChainId == switchToChainId) {
      const asyncFunction = async () => {
        const chainConfigurationName = localStorage.getItem('chainConfigurationName')
        if (chainConfigurationName) {
          logOT.info('QQQQQ  ChainSelectorButtonMenu ', switchToChainId, accountAddr, roleEnum, walletEnum)
          await dispatch(chainActions.disconnectChainConfiguration())
          await dispatch(poolActions.clearPoolState())
          await dispatch(connectToChainThunk({ chainConfigurationName, switchNetwork }))

          await setupStoreWithInitialStateWithChainConnection(store)

          logOT.info('QQQQQ  ChainSelectorButtonMenu connectToChainThunk done', chainConfigurationName)
          if (accountAddr && roleEnum && walletEnum) {
            logOT.info('QQQQQ  ChainSelectorButtonMenu  AppKit BrowserProvider', appKitChainId, chainConfigChainId)
            const chainConfiguration = chainConfigurations.find(
              (chainConfig) => chainConfig.chainConfigurationName === chainConfigurationName
            ) as ChainConfiguration
            const appKitNetwork = convertToAppKitNetwork(chainConfiguration)
            switchNetwork(appKitNetwork as any)

            const network = appKitNetworks.find((network) => network.id === appKitChainId)
            logOT.info('QQQQQ  ChainSelectorButtonMenu network', network)

            const provider = new BrowserProvider(walletProvider, {
              name: network?.name,
              chainId: chainConfiguration.chainId,
            })
            logOT.info('QQQQQ  ChainSelectorButtonMenu provider', provider, await provider.getNetwork())
            const signer = new JsonRpcSigner(provider, getRequiredAddress(accountAddr))
            await dispatch(loginToChainThunk(signer, walletEnum, roleEnum))
            logOT.info('QQQQQ  ChainSelectorButtonMenu login done', accountAddr)
          }

          await dispatch(poolActions.finishedInitializing())
        }
        setSwitchToChainId(undefined)
      }
      asyncFunction()
    }
  }, [switchToChainId, appKitChainId])

  useEffect(() => {
    logOT.info('AppKit appKitChainId', isInitialized, appKitChainId, chainConfigChainId)
    if (chainConfigurationName != 'Hardhat' && appKitChainId !== chainConfigChainId) {
      setNetworkMismatchMessage('Network different than wallet')
    } else {
      setNetworkMismatchMessage(undefined)
    }
  }, [isInitialized, appKitChainId, chainConfigChainId])

  useEffect(() => {
    if (stageName !== selectedStageName) {
      setSelectedStageName(stageName)
    }
    logOT.debug('ChainSelectorButtonMenu useEffect', stageName, selectedStageName)
    if (stageName == selectedStageName) {
      if (chainConfigurations?.length == 1) {
        if (
          !perimeterAddresses ||
          chainConfiguration?.chainConfigurationName !== chainConfigurations[0].chainConfigurationName
        ) {
          const chainConfigurationName = chainConfigurations[0].chainConfigurationName

          logOT.info('ChainSelectorButtonMenu set chainConfigurationName 1', chainConfigurationName)
          localStorage.setItem('chainConfigurationName', chainConfigurationName)
          setSelectedChainConfigurationName(chainConfigurationName)
          dispatch(chainActions.disconnectChainConfiguration())
          dispatch(poolActions.clearPoolState())

          dispatch(connectToChainThunk({ chainConfigurationName, switchNetwork }))
        }
      } else if (!perimeterAddresses) {
        const chainConfigurationName = localStorage.getItem('chainConfigurationName')
        logOT.info('ChainSelectorButtonMenu get chainConfigurationName ', chainConfigurationName)
        if (
          chainConfigurationName &&
          chainConfigurations.find((config) => config.chainConfigurationName === chainConfigurationName)
        ) {
          setSelectedChainConfigurationName(chainConfigurationName)
          dispatch(connectToChainThunk({ chainConfigurationName, switchNetwork }))
        } else if (chainConfigurations.length > 0) {
          const chainConfigurationName = chainConfigurations[0].chainConfigurationName
          logOT.info('ChainSelectorButtonMenu set chainConfigurationName 1', chainConfigurationName)
          localStorage.setItem('chainConfigurationName', chainConfigurationName)
          setSelectedChainConfigurationName(chainConfigurationName)
          dispatch(connectToChainThunk({ chainConfigurationName, switchNetwork }))
        }
      }
    }
  }, [stageName, selectedStageName])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
      {isLocalhost && (
        <Select
          style={{ width: 250 }}
          labelId="stage-label"
          id="stage-select"
          input={<Input id="stage-select" />}
          value={selectedStageName}
          renderValue={(stageName: string) => {
            const stageConfiguration: StageConfiguration | undefined = findStageConfiguration(stageName as StageName)
            return (
              <MenuItem
                value={stageName}
                key={stageName}
                style={{
                  paddingLeft: 12,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                {stageConfiguration && <ListItemText primary={stageName} />}
              </MenuItem>
            )
          }}
          onChange={(event: SelectChangeEvent) => {
            const stageName = event.target.value as StageName

            dispatch(chainActions.disconnectChainConfiguration())
            dispatch(poolActions.clearPoolState())
            dispatch(chainActions.unattachFromStageConfiguration())

            logOT.debug('Selected Stage', stageName)
            setSelectedChainConfigurationName('')
            setSelectedStageName(stageName)

            dispatch(attachToStageThunk({ stageName }))
            navigate('/')
          }}
        >
          {STAGE_CONFIGURATIONS.map((stageConfiguration: StageConfiguration) => {
            return (
              <MenuItem
                value={stageConfiguration.stageName}
                key={`${stageConfiguration.stageName}`}
                style={{
                  paddingLeft: 12,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <ListItemText primary={stageConfiguration.stageName} />
              </MenuItem>
            )
          })}
        </Select>
      )}
      {/* <InputLabel id="asset-label">Network</InputLabel> */}

      <Box sx={{ display: 'flex', flexDirection: 'column', marginLeft: 2, marginRight: 2, alignItems: 'center' }}>
        <Select
          style={{ width: 250 }}
          labelId="network-label"
          id="network-select"
          input={<Input id="network-select" />}
          value={selectedChainConfigurationName}
          renderValue={(chainConfigurationName: string) => {
            const config: ChainConfiguration | undefined = chainConfigurations.find(
              (chainConfiguration: ChainConfiguration) =>
                chainConfiguration.chainConfigurationName === chainConfigurationName
            )
            return (
              <MenuItem
                value={chainConfigurationName}
                key={chainConfigurationName}
                style={{
                  paddingLeft: 12,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                {config && (
                  <ListItemIcon>
                    <ChainIcon chainName={config.chainIcon} />
                  </ListItemIcon>
                )}
                {config && <ListItemText primary={config.chainConfigurationName} />}
              </MenuItem>
            )
          }}
          onChange={(event: SelectChangeEvent) => {
            logOT.info('ChainSelectorButtonMenu onChange', event.target.value)
            const chainConfigurationName = event.target.value as string
            handleChangeChainSelection(chainConfigurationName).catch((error) => {
              logOT.error('handleChangeChainSelection error', error)
            })
          }}
        >
          {chainConfigurations.map((chainConfiguration: ChainConfiguration) => {
            return (
              <MenuItem
                value={chainConfiguration.chainConfigurationName}
                key={`${chainConfiguration.chainConfigurationName}`}
                style={{
                  paddingLeft: 12,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <ListItemIcon>
                  <ChainIcon chainName={chainConfiguration.chainIcon} />
                </ListItemIcon>
                <ListItemText primary={chainConfiguration.chainConfigurationName} />
              </MenuItem>
            )
          })}
        </Select>
        {networkMismatchMessage && <Typography variant="caption">{networkMismatchMessage}</Typography>}
      </Box>
    </Box>
  )
}
